import { gql } from "@apollo/client";

export default gql`
	mutation ($receipt: String!, $language: String!) {
		resendReceipt(receipt: $receipt, language: $language)
	}
`;
